export default "__VITE_ASSET__B6XT2TAZ__"